import React from 'react';
import Header from "./Header";
import Hero from "./Hero";
import Audience from "./Audience";
import CtaBand from "./CtaBand";
import HowItWorks from "./HowItWorks";
import Pricing from "./Pricing";
import Organization from "./Organization";
import Faq from "./Faq";
import FinalCta from "./FinalCta";
import Footer from "./Footer";
import AboutUsSection from "./AboutUsSection";


const CheckInPage = () => {
    return (
        <div className="checkin-landing-wrapper">
            <Header />
            <Hero />
            <Audience />
            <AboutUsSection />
            {/*<CtaBand />*/}
            <HowItWorks />
            <Pricing />
            <Organization />
            <Faq />
            <FinalCta />
            <Footer />

        </div>
    );
};

export default CheckInPage;